import { render, staticRenderFns } from "./EspelhoPonto.vue?vue&type=template&id=1ddebfe0&"
import script from "./EspelhoPonto.vue?vue&type=script&lang=js&"
export * from "./EspelhoPonto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports